/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardContent, CardTitlePrimary } from '@design-system-coopeuch/web';
import { FuturaTarjetaWrapper } from './styles';
import tarjetaBlueDesk from '../../../assets/img/icon/Desk-Dale.svg';
import tarjetaBlueMobile from '../../../assets/img/icon/Mobile-Dale.svg';

import iconcedula from '../../../assets/img/icon/icon-Dale01.svg';
import iconprevisional from '../../../assets/img/icon/icon-Dale03.svg';
import iconliquidacion from '../../../assets/img/icon/icon-Dale02.svg';
import Botonera from '../Footer';

import { properties } from '../../../../utils/properties';
import TagManagerUtils from '../../../../utils/TagManagerUtils';
import { stepperAction } from '../../../../application/actions/stepper';
import { obtieneNombreApellidos } from '../../../../utils';
import ModalEncuestaAbandono from '../../organisms/ModalEncuestaAbandono';
import ModalRespuestaEncuesta from '../../organisms/ModalRespuestaEncuesta';
import { verificacionActions } from '../../../../application/actions/verificacion';

const BlueCard = () => {
  const dispatch = useDispatch();
  const [nombreCliente, setNombreCliente] = useState('');

  const [tipoRespuesta, setTipoRespuesta] = useState('');
  const [openModalEncuestaAbandono, setOpenModalEncuestaAbandono] = useState(false);
  const [openModalRespuestaEncuesta, setOpenModalRespuestaEncuesta] = useState(false);
  const [encuestaRespondida, setEncuestaRespondida] = useState(false); // pendiente backend

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const history = useHistory();

  const { futuratarjeta } = properties;
  const { boteneraTextosDale } = futuratarjeta;

  const storeDataVerificacion = useSelector((store) => store.entities.verificacion.response);

  const [state] = useState({
    botones: [{ nameUno: boteneraTextosDale.botonDos, nameDos: boteneraTextosDale.botonUno }],
  });

  const verificar = () => {
    TagManagerUtils.triggerEventMetodoThree(
      'trigger_event',
      'No Socio',
      '/solicitud-tarjeta-credito/paso3/solicitar-tarjeta-dale',
      'Click',
      'Solicitar mi tarjeta Dale'
    );
    window.location.href = properties.urlTarjetaDale;
  };

  useEffect(() => {
    dispatch(stepperAction.fetchStepper(3));
    TagManagerUtils.vpvMetodo(
      'vpv',
      '/solicitud-tarjeta-credito/paso3/solicitar-tarjeta-dale',
      'No socio'
    );

    if (storeDataVerificacion.length === 0) {
      dispatch(
        verificacionActions.verificacion({ trackId: window.localStorage.getItem('track_id') })
      );
    }
  }, []);

  useEffect(() => {
    if ('code' in storeDataVerificacion && storeDataVerificacion.code === -1) {
      window.localStorage.setItem('paso', '/tu-futura-tarjeta/dale');
      history.push('/error-conexion');
    }
    if (storeDataVerificacion.length !== 0 && storeDataVerificacion.data) {
      const dataPersist = storeDataVerificacion.data;

      if (!('socio' in dataPersist)) {
        // viene de redirección desde paso 1
        dispatch(verificacionActions.verificacion({ trackId: dataPersist.token }));
        return;
      }

      const { nombres, primerApellido, segundoApelllido } = dataPersist;
      setNombreCliente(obtieneNombreApellidos(nombres, primerApellido, segundoApelllido));

      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 2000);
    }
  }, [storeDataVerificacion]);

  const volverACoopeuch = () => {
    window.location.href = properties.urlCoopeuch;
  };

  const retomarEncuesta = () => {
    setOpenModalEncuestaAbandono(true);
    setOpenModalRespuestaEncuesta(false);
  };

  const { botones } = state;

  return (
    <FuturaTarjetaWrapper>
      <div className="futura-tarjeta-header-blue">
        <div className="t-internacional t-internacional-texto">
          <p className="titulo">{properties.futuratarjeta.bluecard}</p>
          <p className="subtitulo"> Obténla solo con tu Rut.</p>
          <p className="subtitulo"> Es gratis y sin requisitos.</p>
          <p className="subtitulo"> La mejor tarjeta virtual prepago es Dale.</p>
        </div>
        <div className="t-internacional">
          <img className="tarjetainternacional desktop" src={tarjetaBlueDesk} alt="internacional" />
          <img
            className="tarjetainternacional mobile"
            src={tarjetaBlueMobile}
            alt="internacional"
          />
          <p className="p-dale">{nombreCliente}</p>
        </div>
      </div>
      <div className="card">
        <Card className="Card-Class">
          <CardTitlePrimary title={properties.futuratarjeta.BeneficiosDale.textoBeneficios} />
          <CardContent>
            <div className="contenedor-blue-card">
              <div className="info">
                <img className="iconcedula" src={iconcedula} alt="cedula" />
                <p className="p-mensaje">{properties.futuratarjeta.BeneficiosDale.titulo1}</p>
                <p className="p-coment">{properties.futuratarjeta.BeneficiosDale.texto1}</p>
              </div>
              <div className="info">
                <img className="iconliquidacion" src={iconliquidacion} alt="liquidacion" />
                <p className="p-mensaje">{properties.futuratarjeta.BeneficiosDale.titulo2}</p>
                <p className="p-coment">{properties.futuratarjeta.BeneficiosDale.texto2}</p>
              </div>
              <div className="info">
                <img className="iconprevision" src={iconprevisional} alt="prevision" />
                <p className="p-mensaje">{properties.futuratarjeta.BeneficiosDale.titulo3}</p>
                <p className="p-coment">{properties.futuratarjeta.BeneficiosDale.texto3}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
      <Botonera
        tituloboton={botones}
        verificarFunction={verificar}
        volverHome={
          process.env.REACT_APP_HABILITAR_ENCUESTAS === 'true'
            ? setOpenModalEncuestaAbandono
            : volverACoopeuch
        }
        estadoBotonUno
        estadoBotonDos={false}
        nombreDinamicoResponsive={false}
      />
      {openModalEncuestaAbandono && (
        <ModalEncuestaAbandono
          setTipoRespuesta={setTipoRespuesta}
          setOpenModalEncuestaAbandono={setOpenModalEncuestaAbandono}
          setOpenModalRespuestaEncuesta={setOpenModalRespuestaEncuesta}
          setEncuestaRespondida={setEncuestaRespondida}
        />
      )}
      {openModalRespuestaEncuesta && (
        <ModalRespuestaEncuesta
          tipoRespuesta={tipoRespuesta}
          setOpenModalRespuestaEncuesta={setOpenModalRespuestaEncuesta}
          titulo={
            tipoRespuesta === 'exito'
              ? properties.encuestaAbandono.exitoTitulo
              : properties.encuestaAbandono.errorTitulo
          }
          descripcion={
            tipoRespuesta === 'exito'
              ? properties.encuestaAbandono.exitoDescripcion
              : properties.encuestaAbandono.errorDescripcion
          }
          botonAccion={tipoRespuesta === 'exito' ? volverACoopeuch : retomarEncuesta}
          botonTexto={
            tipoRespuesta === 'exito'
              ? properties.encuestaAbandono.exitoBoton
              : properties.encuestaAbandono.errorBoton
          }
        />
      )}
    </FuturaTarjetaWrapper>
  );
};

export default BlueCard;
